export default "__VITE_ASSET__bd541d89__"